import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import FandBForm from './forms/FandBForm';
import { FormattedMessage } from 'react-intl';

const FandB = ({ listing, isFandB, ...props }) => {
  const prices = get(listing, 'prices.0', {});
  const initialIsFandB = get(listing, 'fandb_required', false);

  return (
    <div className="margin-xl-top">
      <p className="heavy"><FormattedMessage id="hosting.f_and_b.food_purchase_text" defaultMessage="Do you require a minimum purchase of food and/or drinks to book the space?"/></p>
      <div className="clearfix" />
      <div className="row margin-lg-top">
        <div className="col-xs-12">
          <FandBForm
            {...props}
            listing={listing}
            isFandB={isFandB}
            initialValues={{
              fandb: {
                fandb_required: initialIsFandB,
                fandb_applies_to: get(listing, 'fandb_applies_to') || 'FOOD_BEV'
              },
              prices
            }}
          />
        </div>
      </div>
    </div>
  );
};

FandB.propTypes = {
  listing: PropTypes.object.isRequired,
  isFandB: PropTypes.bool.isRequired
};

export default FandB;
